import React from 'react';
import PropTypes from 'prop-types';
import ResultsModal from './ResultsModal';
import QuickQuoteForm from './QuickQuoteForm';
import { getFullUrl } from '../../utils/utils';
import { useQuickQuoteContext } from 'contexts/QuickQuoteContext';

const QuickQuote = ({ className, title, couponCode, buttonText, breakText }) => {

  const { shipParams } = useQuickQuoteContext();

  const submitQuickQuote = () => {
      window?.startShipppingRudderstackEvent();
      const path = `/ship?${shipParams}${couponCode ? `&coupon=${couponCode}` : ''}`
      window.location.href = getFullUrl(path, window.gon?.subdomain);
  };

  return (
    <>
      <ResultsModal
        submitQuickQuote={submitQuickQuote}
      />
      <div className={`
        ${className} w-full flex flex-col items-center justify-center text-center space-y-2
        bg-white border border-gray-300 px-4 py-6 rounded-2xl lg:max-w-[50%]
      `}>
          <div className="text-[20px] font-semibold text-[#1C2938] mb-5 md:pt-3 lg:px-4">
            {title ? title : (<div>Simplify travel. <br /> Let us lighten the load.</div>)}
          </div>

          <QuickQuoteForm
            buttonText={buttonText}
            breakText={breakText}
          />
      </div>
    </>
  );
}

QuickQuote.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  couponCode: PropTypes.string,
  buttonText: PropTypes.string,
  breakText: PropTypes.string,
};

export default QuickQuote;
